// extracted by mini-css-extract-plugin
module.exports = {"comments":"e_7e","related":"e_8e","breadCrumbs":"e_9e","postTags":"e_-e","sidebarPostNav":"e_af"};